import {
  FETCH_TANENTS,
  FETCH_TANENTS_SUCCESS,
  TANENT_NAME,
  TANENT_EMAIL,
  TANENT_DESCRIPTION,
  TANENT_CREATE,
  TANENT_ACTION_SUCCESS,
  TANENT_STATUS_CHANGE_DIALOG_BOX,
  TANENT_CHANGE_STATUS_ID,
  TANENT_STATUS_CHANGE,
} from "../constants/tanent.constants";

export const getTanents = (page) => {
  return {
    type: FETCH_TANENTS,
    page: page,
  };
};

export const getTanentsSuccess = (tanents) => {
  return {
    type: FETCH_TANENTS_SUCCESS,
    tanents: tanents,
  };
};

export const onChangeTanentName = (name) => {
  return {
    type: TANENT_NAME,
    name: name,
  };
};

export const onChangeTanentEmail = (email) => {
  return {
    type: TANENT_EMAIL,
    email: email,
  };
};

export const onChangeTanentDescription = (description) => {
  return {
    type: TANENT_DESCRIPTION,
    description: description,
  };
};

export const onSubmitTanentCreate = (tanent_data) => {
  return {
    type: TANENT_CREATE,
    tanent_data: tanent_data,
  };
};

export const onSubmitTanentActionSuccess = (tanents) => {
  return {
    type: TANENT_ACTION_SUCCESS,
    tanents: tanents,
  };
};

export const onStatusChangeDialogBox = (status) => {
  return {
    type: TANENT_STATUS_CHANGE_DIALOG_BOX,
    status: status,
  };
};

export const onChangeTanentStatusId = (id, status) => {
  return {
    type: TANENT_CHANGE_STATUS_ID,
    id: id,
    status: status,
  };
};

export const onSubmitTanentStatusChange = (tanent_edit_data) => {
  return {
    type: TANENT_STATUS_CHANGE,
    tanent_edit_data: tanent_edit_data,
  };
};
